import { updateKeyInStore } from 'App';
import { BusinessTypeStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof BusinessTypeStateValues> | {}[] = [
  {
    name: 'pleaseUploadACopyOfIrsSCorpApprovalLetter',
    label: 'Please upload a copy of IRS S Corp Approval Letter.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: string) => v === 'yes',
    dependentOn:
      'taxQuestionnaire.businessInfo.businessType.values.doYouHaveCopyOfYourIrsSCorpApprovalLetter',
  },
];
